export class WebRecadParticipanteDadosEntidade {
  CD_FUNDACAO: string | null = null;
  SEQ_RECEBEDOR: string | null = null;
  NUM_INSCRICAO: string | null = null;
  CD_EMPRESA: string | null = null;
  NOM_EMPRESA: string | null = null;
  NUM_MATRICULA: string | null = null;
  NOME_ENTID: string | null = null;
  DT_NASCIMENTO: string | null = null;
  CPF_CGC: string | null = null;
  NU_IDENT: string | null = null;
  ORG_EMIS_IDENT: string | null = null;
  DT_EMIS_IDENT: string | null = null;
  NATURALIDADE: string | null = null;
  UF_NATURALIDADE: string | null = null;
  DS_UF_NATURALIDADE: string | null = null;
  NOME_MAE: string | null = null;
  NOME_PAI: string | null = null;
  CD_ESTADO_CIVIL: string | null = null;
  DS_ESTADO_CIVIL: string | null = null;
  NOME_CONJUGE: string | null = null;
  CPF_CONJUGE: string | null = null;
  CEP_ENTID: string | null = null;
  END_ENTID: string | null = null;
  NR_END_ENTID: string | null = null;
  COMP_END_ENTID: string | null = null;
  BAIRRO_ENTID: string | null = null;
  CID_ENTID: string | null = null;
  UF_ENTID: string | null = null;
  DS_UF_ENTID: string | null = null;
  CD_PAIS: string | null = null;
  EMAIL_AUX: string | null = null;
  FONE_CELULAR: string | null = null;
  FONE_ENTID: string | null = null;
  NUM_BANCO: string | null = null;
  NUM_AGENCIA: string | null = null;
  NUM_CONTA: string | null = null;
  POLIT_EXP: string | null = null;
  CD_ESPECIE_INSS: string | null = null;
  DS_ESPECIE_INSS: string | null = null;
  NUM_PROCESSO_PREV: string | null = null;
  IND_PPE_FAMILIAR: string | null = null;
  DTA_INI_PPE: string | null = null;
  DTA_FIM_PPE: string | null = null;
  UF_EMIS_IDENT: string | null = null;
  IND_ENDERECO_NACIONAL: string | null = null;
  Planos: Array<any> = new Array<any>();
}